export const SET_PRODUCT_TYPE = 'Product type set 🏬';
